// components/Footer/PureFooter.tsx
import React from 'react';
import styles from './MegaFooter.module.scss';
import { PureFooterMenu, RegionSelectorData, PureNewsLetter } from '../types';
import NextLink from 'next/link';
import clsx from 'clsx';
import { RegionSelector } from './RegionSelector/RegionSelector';
import Newsletter from '../NewsLetter/NewsLetter';
import useDictionary from 'lib/hooks/useDictionary';

type Props = {
  pureFooterMenu: PureFooterMenu;
  footerLogo?: React.ReactNode;
  newsLetterHeadline?: React.ReactNode;
  regionSelectorData?: RegionSelectorData;
  pureNewsLetter?: PureNewsLetter;
};

const MegaFooter: React.FC<Props> = ({
  pureFooterMenu,
  footerLogo,
  newsLetterHeadline,
  regionSelectorData,
  pureNewsLetter,
}) => {
  const { getDictionaryValue } = useDictionary();
  const showNewsLetterSection = Boolean(newsLetterHeadline);
  if (pureFooterMenu.columns.length === 0) {
    return null;
  }
  const renderMenuSections = () => {
    return pureFooterMenu.columns.map((column, index) => {
      const sectionId = `footer-section-${index}`;
      return (
        <section
          key={index}
          className={clsx(
            styles.megaFooterSection,
            styles[
              `sectionsPerRow_${showNewsLetterSection || pureFooterMenu.columns.length < 4 ? 3 : 4}`
            ]
          )}
        >
          <div id={sectionId} className="megaFooterSectionHeading" role="heading" aria-level={2}>
            {column.headerText}
          </div>
          <ul aria-labelledby={sectionId}>
            {column.links.map((footerLink, linkIndex) => {
              if (!footerLink.link) return null;
              return (
                <li key={linkIndex} className={styles.linkListItem}>
                  {footerLink.link}
                </li>
              );
            })}
          </ul>
        </section>
      );
    });
  };

  return (
    <div className={styles.megaFooterWrapper}>
      <div className={styles.megaFooter}>
        {footerLogo && (
          <NextLink
            aria-label={getDictionaryValue('Navigation.Footer.SiteLogo') || 'Site logo'}
            className={styles.footerLogoWrapper}
            href="/"
          >
            {footerLogo}
          </NextLink>
        )}
        <div className={styles.megaFooterNavContainer}>
          {(pureNewsLetter || regionSelectorData) && (
            <div className={styles.megaFooterOptionalContent}>
              {pureNewsLetter && <Newsletter data={pureNewsLetter} />}
              {regionSelectorData && <RegionSelector regionSelectorData={regionSelectorData} />}
            </div>
          )}
          {showNewsLetterSection && (
            <div className={styles.newsLetterSection}>
              {/* Newsletter Section goes here */}
              <div className={styles.newsLetterHeadline}>{newsLetterHeadline}</div>
            </div>
          )}
          {pureFooterMenu && (
            <nav aria-label={pureFooterMenu.mainNavigationLabel} className={styles.megaFooterNav}>
              {renderMenuSections()}
            </nav>
          )}
        </div>
      </div>
    </div>
  );
};

export default MegaFooter;
